var map = {
	"./Hosenrolle_image_main.png": 8256,
	"./forschungslabor/forschungslabor": 6386,
	"./forschungslabor/forschungslabor.json": 6386,
	"./forschungslabor/forschungslabor_sepidar_recherche_blue_square.webp": 8766,
	"./forschungslabor/forschungslabor_sepidar_recherche_blue_square_2.webp": 8845,
	"./hedera/hedera": 5733,
	"./hedera/hedera.json": 5733,
	"./hedera/hedera_hedera-poster.webp": 520,
	"./hedera/hedera_x_P2280138-Verbessert-RR.webp": 849,
	"./hedera/hedera_x_P2280206-Verbessert-RR.webp": 5787,
	"./hedera/hedera_x_P2280228-Verbessert-RR-2.webp": 9204,
	"./hedera/hedera_x_P2280266-Verbessert-RR.webp": 3254,
	"./hedera/hedera_x_P2280402-Verbessert-RR.webp": 3528,
	"./hosenrolle/hosenrolle": 1087,
	"./hosenrolle/hosenrolle.json": 1087,
	"./hosenrolle/hosenrolle__DSC9188.webp": 7868,
	"./hosenrolle/hosenrolle__DSC9192.webp": 9917,
	"./hosenrolle/hosenrolle__DSC9230.webp": 7496,
	"./hosenrolle/hosenrolle__DSC9243.webp": 2706,
	"./hosenrolle/hosenrolle__DSC9254.webp": 5031,
	"./hosenrolle/hosenrolle__DSC9258.webp": 2066,
	"./hosenrolle/hosenrolle__DSC9259.webp": 5762,
	"./hosenrolle/hosenrolle__DSC9278.webp": 8436,
	"./hosenrolle/hosenrolle__DSC9281.webp": 9263,
	"./hosenrolle/hosenrolle__DSC9299.webp": 3768,
	"./hosenrolle/hosenrolle__DSC9300.webp": 3178,
	"./hosenrolle/hosenrolle__DSC9312.webp": 9232,
	"./hosenrolle/hosenrolle__DSC9315.webp": 5209,
	"./hosenrolle/hosenrolle__DSC9343.webp": 3633,
	"./hosenrolle/hosenrolle__DSC9344.webp": 7084,
	"./hosenrolle/hosenrolle__DSC9347.webp": 5669,
	"./hosenrolle/hosenrolle__DSC9362.webp": 5753,
	"./hosenrolle/hosenrolle__DSC9370.webp": 4500,
	"./hosenrolle/hosenrolle__DSC9377.webp": 3797,
	"./hosenrolle/hosenrolle__DSC9389.webp": 153,
	"./hosenrolle/hosenrolle__DSC9397.webp": 9392,
	"./hosenrolle/hosenrolle__DSC9436.webp": 5103,
	"./hosenrolle/hosenrolle__DSC9458.webp": 4566,
	"./hosenrolle/hosenrolle__DSC9475.webp": 5562,
	"./hosenrolle/hosenrolle__DSC9487.webp": 4203,
	"./hosenrolle/hosenrolle__DSC9490.webp": 6631,
	"./hosenrolle/hosenrolle__DSC9496.webp": 4636,
	"./hosenrolle/hosenrolle__DSC9500.webp": 3220,
	"./hosenrolle/hosenrolle__DSC9507.webp": 7095,
	"./ich-bin-schon-tot.jpg": 236,
	"./ich-bin-schon-tot/ich-bin-schon-tot": 8808,
	"./ich-bin-schon-tot/ich-bin-schon-tot.json": 8808,
	"./ich-bin-schon-tot/ich-bin-schon-tot_Kopie von x_P1510047.webp": 3089,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510116.webp": 6162,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510156.webp": 574,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510454.webp": 8678,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510466.webp": 5068,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510496.webp": 6967,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510501.webp": 6854,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510751.webp": 4426,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1510950.webp": 1646,
	"./ich-bin-schon-tot/ich-bin-schon-tot_x_P1520066.webp": 9825,
	"./ich-werde-tier-sein.jpg": 6501,
	"./ich-werde-tier-sein/ich-werde-tier-sein": 2190,
	"./ich-werde-tier-sein/ich-werde-tier-sein.json": 2190,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180459-Verbessert-RR.webp": 2846,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180462-Verbessert-RR.webp": 2086,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180478-Verbessert-RR.webp": 5433,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180534-Verbessert-RR.webp": 8317,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180559-Verbessert-RR.webp": 7233,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180572-Verbessert-RR.webp": 5520,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180583-Verbessert-RR.webp": 3262,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180768-Verbessert-RR.webp": 336,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180847-Verbessert-RR.webp": 3741,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180908-Verbessert-RR.webp": 118,
	"./ich-werde-tier-sein/ich-werde-tier-sein_P2180960-Verbessert-RR.webp": 7827,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180418-Verbessert-RR.webp": 9664,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180427-Verbessert-RR.webp": 9687,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180450-Verbessert-RR.webp": 4014,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180662-Verbessert-RR.webp": 3880,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180680-Verbessert-RR.webp": 6377,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180699-Verbessert-RR.webp": 4135,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_P2180912-Verbessert-RR.webp": 4634,
	"./ich-werde-tier-sein/ich-werde-tier-sein_x_beschnitt_P2180786-Verbessert-RR.webp": 9863,
	"./logos/2025_ak_mkw_nrw_rgb.png": 7274,
	"./logos/DasSchaubuedchen_Logo_RGB_RZ.png": 7305,
	"./logos/StadtBochum_Logo_Blau.png": 6309,
	"./logos/kulturbuero-und-stadt-dortmund.jpeg": 5284,
	"./logos/lwl.jpeg": 4999,
	"./phantomschmerz/phantomschmerz": 5159,
	"./phantomschmerz/phantomschmerz.json": 5159,
	"./phantomschmerz/phantomschmerz__DSC3454(3).webp": 7146,
	"./phantomschmerz/phantomschmerz__DSC3477(2).webp": 7697,
	"./phantomschmerz/phantomschmerz__DSC3502(8).webp": 3620,
	"./phantomschmerz/phantomschmerz__DSC3539(9).webp": 2777,
	"./phantomschmerz/phantomschmerz__DSC3556(5).webp": 7007,
	"./phantomschmerz/phantomschmerz__DSC3584(4).webp": 3171,
	"./phantomschmerz/phantomschmerz__DSC3587(7).webp": 4768,
	"./phantomschmerz/phantomschmerz__DSC3615(6).webp": 4701,
	"./phantomschmerzThumbnail.jpg": 688,
	"./phantomschmerz_img1.jpg": 2481,
	"./phantomschmerz_img2.jpg": 5521,
	"./phantomschmerz_img3.jpg": 3807,
	"./project-covers/cover-forschungslabor.webp": 4769,
	"./project-covers/cover-hedera.webp": 3638,
	"./project-covers/cover-hosenrolle.webp": 2339,
	"./project-covers/cover-ichBinSchonTot.webp": 4478,
	"./project-covers/cover-ichWerdeTierSein.webp": 7068,
	"./project-covers/cover-phantomschmerz.webp": 4869,
	"./project-covers/project-covers": 8722,
	"./project-covers/project-covers.json": 8722,
	"./project-covers/project-covers_cover-hosenrolle.webp": 6797,
	"./project-covers/project-covers_cover-ichBinSchonTot.webp": 2344,
	"./project-covers/project-covers_cover-ichWerdeTierSein.webp": 8601,
	"./project-covers/project-covers_cover-phantomschmerz.webp": 453,
	"./sepidar-team.jpg": 305,
	"./sepidar_logo.png": 3295,
	"./sepidar_logo_small.png": 3447,
	"./sepidar_team.jpg": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;